import React from 'react';
import { Card } from 'antd';

/**
 * SectionCard — セクションカード
 * ------------------------------------------------------------------
 * antd Card を薄くラップした共通カード。デザインシステムの
 * --shadow-card（影） + --radius-xl（角丸 10px） + --space-5（本文 padding）を適用する。
 *
 * 設計方針（Ph.3）:
 *   - antd Card の API をそのまま踏襲（title / extra / loading 等は素通し）。
 *   - 既定で variant="borderless"（罫線なし）+ 影で「浮いたカード」を表現。
 *     Cream 背景（Ph.4）上でカードが自然に浮く想定。
 *   - 本文 padding は新 API の styles.body で指定（Ph.B 定着済み。bodyStyle 再導入禁止）。
 *   - 影・角丸・余白は tokens.css の CSS 変数のみ使用（HEX 禁止）。
 *
 * @param {object}      props
 * @param {React.ReactNode} [props.children]          カード本文
 * @param {React.ReactNode} [props.title]             カード見出し（antd Card と同じ）
 * @param {React.ReactNode} [props.extra]             見出し右側の領域（antd Card と同じ）
 * @param {'borderless'|'outlined'} [props.variant='borderless'] 罫線の有無（antd 5.29 の variant）
 * @param {object}      [props.styles]                antd Card の styles（body/header 等。マージされる）
 * @param {React.CSSProperties} [props.style]         カード外枠の追加スタイル（マージされる）
 *  ...rest                                           その他 antd Card props を素通し
 *
 * @example
 * <SectionCard title="基本情報">
 *   <Descriptions ... />
 * </SectionCard>
 */
const SectionCard = ({
  children,
  variant = 'borderless',
  styles,
  style,
  ...rest
}) => {
  const mergedStyle = {
    borderRadius: 'var(--radius-xl)',
    boxShadow: 'var(--shadow-card)',
    ...style,
  };

  // 本文 padding をトークンに統一（呼び出し側 styles.body で上書き可能）
  const mergedStyles = {
    ...styles,
    body: {
      padding: 'var(--space-5)',
      ...(styles && styles.body),
    },
  };

  return (
    <Card variant={variant} style={mergedStyle} styles={mergedStyles} {...rest}>
      {children}
    </Card>
  );
};

export default SectionCard;
